import { defineMessages } from 'react-intl';

import { TestimonialSchema } from '@fhnw/schemas/testimonial';

const messages = defineMessages({
  Testimonials: {
    id: 'Testimonials',
    defaultMessage: 'Testimonials',
  },
  Prominent: {
    id: 'label_prominent',
    defaultMessage: 'Prominent',
  },
  ProminentHelp: {
    id: 'help_prominent',
    defaultMessage: 'Display testimonials in a prominent style.',
  },
});

const Schema = (props) => {
  return {
    title: props.intl.formatMessage(messages.Testimonials),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['prominent', 'testimonials'],
      },
    ],

    properties: {
      prominent: {
        title: props.intl.formatMessage(messages.Prominent),
        description: props.intl.formatMessage(messages.ProminentHelp),
        widgetOptions: {
          frontendOptions: {
            widget: 'checkbox',
          },
        },
      },
      testimonials: {
        title: props.intl.formatMessage(messages.Testimonials),
        widgetOptions: {
          frontendOptions: {
            widget: 'custom_object_list_widget',
            widgetProps: {
              schema: TestimonialSchema(props),
            },
          },
        },
      },
    },
    required: [],
  };
};

export default Schema;
